import React, { Fragment, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";


function PgPayments({ permissions = {}, isSuperAdmin }) {
  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">DD/Offline PG payments</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    DD/Offline PG payments
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">View all DD/offline PG payments</h3>
        </div>

        <div className="card-body">card body</div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default PgPayments;
